export default __webpack_public_path__ + "static/media/Logo_ComVocêONatalSeTransforma_Natal2025_v1.27a19ffa.png";